import React, { Component } from "react";
import "./App.css";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";

import CssBaseline from "@material-ui/core/CssBaseline";
import Encabezado from "./components/Encabezado";
import AccountForm from "./components/AccountForm";
import CuentasServicio from "./components/CuentasServicio";
import PiePagina from "./components/PiePagina";
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';
import EscogerBusqueda from "./components/EscogerBusqueda";
import Typography from '@material-ui/core/Typography';
import axios from "axios";
import MuestraAlerta from "./components/MuestraAlerta";
import BotonAuthorize from "./components/BotonAuthorize";
import CuentasConfirma from "./components/CuentasConfirma";
import AcuseRecibo from "./components/AcuseRecibo";
import LinearProgress from '@material-ui/core/LinearProgress';
import ReCAPTCHA from "react-google-recaptcha";
import IdleTimer from 'react-idle-timer';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import { withTranslation } from 'react-i18next';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#fe7c2e", // Orange
      contrastText: "#fff"
    },
    secondary: {
      main: "#1f9bde",
      contrastText: "#fff"
    }
  },
  typography: {
    useNextVariants: true
  }
});

const styles = theme => ({
  root: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  button: {
    marginRight: theme.spacing(1),
  },
  stepper: {
    '& .MuiStepper-root': {
      padding: '24px 0 24px 0'
    },
    '& .MuiStep-horizontal': {
      paddingRight: 0,
    },
  },
});

const pasos = ['pagos:Tipo', 'pagos:Buscar', 'pagos:Selección', 'pagos:ConfirmarPagar'];

const initialState = {
  muestraAlerta: false,
  tituloDialogo: 'pagos:tituloerror',
  mensajeDialogo: [],
  valoresDialogo: [],
  detalleDialogo: [],
  valoresDetalleDialogo: [],
  respCuentasMovil: [],
  cuentasMovil: {},
  cuentasSeleccionadas: [],
  pasoActivo: 0,
  omitidos: new Set(),
  tipoBusqueda: '',
  valorBusqueda: '',
  codigoPostal: '',
  pagosSugeridos: new Map(),
  pagosIngresados: new Map(),
  erroresPagos: new Map(),
  tipoNotificacion: '',
  destinoNotificacion: '',
  errorDestinoNotifica: '',
  completa: false,
  muestraProgreso: false,
  captchaValido: false,
  captchaExpiro: false,
  timeout: 1000 * 60 * 2.5,
  muestraInactividad: false,
  estaInactivo: false,
  parametrosEmbebido: {valor1: null, valor2: null, valor3: null}
};

class App extends Component {
  constructor(props) {
    super(props);
    window.paymentFormUpdate = this.paymentFormUpdate.bind(this);
    window.errorAuthorize = this.errorAuthorize.bind(this);
    this.state = initialState;
    this.scrollRef = React.createRef();
    this.idleTimer = null;
    this.onAction = this._onAction.bind(this);
    this.onActive = this._onActive.bind(this);
    this.onIdle = this._onIdle.bind(this);
  }

  _onAction(e) {
    // console.log('user did something', e);
    this.setState({ estaInactivo: false });
  }

  _onActive(e) {
    // console.log('user is active', e);
    this.setState({ estaInactivo: false });
  }

  _onIdle(e) {
    // console.log('user is idle', e);
    // console.log(' paso ', this.state.pasoActivo);
    const { estaInactivo, captchaValido, muestraProgreso, completa, muestraInactividad } = this.state;
    if (estaInactivo || muestraInactividad) {
      this.reset();
    } else {
      if (this.state.pasoActivo > 0 && !muestraProgreso && !completa) {
        this.setState({ muestraInactividad: true });
        if (captchaValido) {
          window.grecaptcha.reset();
        }
        this.idleTimer.reset();
        this.setState({ estaInactivo: true });
      }
    }
  }

  componentDidUpdate() {
    this.scrollDown();
  }

  scrollDown = () => {
    //    console.error('--------------')
    //    console.error('pasoActivo', this.state.pasoActivo)
    //    console.error('--------------')
    if (this.state.pasoActivo === 2) {
      this.el.scrollIntoView({ behavior: 'smooth' });
    }
  }

  paymentFormUpdate = async resPaymentNonce => {
    let requestPago = {};
    let tituloDialogo = '';
    let mensajeDialogo = [];
    let valoresDialogo = [];
    let detalleDialogo = [];
    let valoresDetalleDialogo = [];
    let direccionIP = '';

    let resws;
    let reswsIP;
    const { dataDescriptor, dataValue } = resPaymentNonce.opaqueData;
    const { cuentasSeleccionadas, tipoNotificacion, destinoNotificacion, valorBusqueda } = this.state;
    const userId = '764580121';
    let url = process.env.REACT_APP_URL_PAGOS_DEV;
    let urlIP = process.env.REACT_APP_URL_OBTENER_IP;
    if (process.env.NODE_ENV === 'production') {
      url = process.env.REACT_APP_URL_PAGOS_PROD;
    }

    reswsIP = await axios
      .get(urlIP)
      .catch(error => {
        console.log('ERROR ', error);
      });
    if (reswsIP.status === 200 && reswsIP.statusText === 'OK') {
      direccionIP = reswsIP.data.ip;
      console.log('direccion IP', direccionIP);
    } else {
      console.log('No se pudo obtener la direccion IP', reswsIP.status, reswsIP.statusText);
    }

    requestPago = {
      idLog: valorBusqueda,
      dataDescriptor,
      dataValue,
      userId,
      cuentasSeleccionadas,
      tipoNotificacion,
      destinoNotificacion,
      reference: 'AB125DFS66654',
      terminal: 'PP1234',
      direccionIP,
    };
    // console.warn("[REQUEST]", requestPago);
    this.setState({ muestraProgreso: true });
    let credenciales = process.env.REACT_APP_CLIENT_CREDENTIALS_DEV;
    if (process.env.NODE_ENV === 'production') {
      credenciales = process.env.REACT_APP_CLIENT_CREDENTIALS_PROD;
    }

    const headers = {
      'Authorization': 'Basic ' + credenciales
    }
    // console.log('CREDENCIALES pago', headers)

    try {
      resws = await axios
        .post(url, requestPago, {
          headers: headers
        });
    } catch (err) {
      // console.log(' ERROR ', err);
      tituloDialogo = 'pagos:tituloerror';
      mensajeDialogo.push('pagos:errorgeneral');
      this.setState({ muestraAlerta: true, tituloDialogo, mensajeDialogo, muestraProgreso: false });
      return;
    }
    // console.log("[respuesta] data", resws.data);
    this.setState({ muestraProgreso: false });
    const { transactionStatus, responseStatus, contacto_sac1, transaccionId } = resws.data;
    if (transactionStatus && transactionStatus.responseStatus.responseCode === 0) {
      tituloDialogo = 'pagos:transexitosa';
      mensajeDialogo.push('pagos:transid');
      valoresDialogo.push(' : ' + transactionStatus.reference);
      if (transactionStatus.id_transaccion) {
        mensajeDialogo.push('pagos:noautoriza');
        valoresDialogo.push(' : ' + transactionStatus.id_transaccion);
      }
      if (transactionStatus.pagos && transactionStatus.pagos.length > 0) {
        for (let i in transactionStatus.pagos) {
          detalleDialogo.push('pagos:msjpago1');
          valoresDetalleDialogo.push(transactionStatus.pagos[i].moneda + ' ' + parseFloat(transactionStatus.totalPagos).toFixed(2));
          detalleDialogo.push('pagos:msjpago2');
          valoresDetalleDialogo.push(transactionStatus.pagos[i].nombreProducto);
          detalleDialogo.push('pagos:msjpago3');
          valoresDetalleDialogo.push('');
          // console.log('fechaExpiracionServicio', transactionStatus.pagos[i].fechaExpiracionServicio);
          // console.log('ExpiracionServicio.length', transactionStatus.pagos[i].fechaExpiracionServicio.length);
          if (transactionStatus.pagos[i].fechaExpiracionServicio && transactionStatus.pagos[i].fechaExpiracionServicio.length > 8) {
            detalleDialogo.push('pagos:msjpago4');
            valoresDetalleDialogo.push(transactionStatus.pagos[i].fechaExpiracionServicio.split("T")[0]);
            // console.log('minutosDisponibles', transactionStatus.pagos[i].minutosDisponibles);
            const tieneDigios = /^\d+$/.test(transactionStatus.pagos[i].minutosDisponibles);
            // console.log('tieneDigios', tieneDigios);
            if (transactionStatus.pagos[i].minutosDisponibles && tieneDigios) {
              detalleDialogo.push('pagos:msjpago5');
              valoresDetalleDialogo.push(transactionStatus.pagos[i].minutosDisponibles);
              detalleDialogo.push('pagos:msjpago6');
            }
          }
        }
      }
      this.setState({ muestraAlerta: true, tituloDialogo, mensajeDialogo, completa: true, valoresDialogo, detalleDialogo, valoresDetalleDialogo });
    } else if (responseStatus && responseStatus.responseCode !== 0) {
      tituloDialogo = 'pagos:tituloerror';
      mensajeDialogo.push('pagos:mensajegenerico');
      // console.error('contacto_sac1', contacto_sac1);
      valoresDialogo.push(contacto_sac1);
      this.setState({ muestraAlerta: true, tituloDialogo, mensajeDialogo, valoresDialogo, completa: true });
    } else {
      if (resws.data.errorCode !== 200) {
        if (resws.data.errorCode === -2 || (transactionStatus && transactionStatus.responseStatus.responseCode === 2)) {
          tituloDialogo = 'pagos:transexitosa';
          mensajeDialogo.push('pagos:autorizacionsinpago');
          valoresDialogo.push(contacto_sac1);
          mensajeDialogo.push('pagos:transid');
          valoresDialogo.push(' : ' + (transaccionId) ? transaccionId : transactionStatus.reference);
          this.setState({ muestraAlerta: true, tituloDialogo, mensajeDialogo, valoresDialogo, completa: true });
        } else {
          tituloDialogo = 'pagos:tituloerror';
          mensajeDialogo.push('pagos:errorgeneral');
          this.setState({ muestraAlerta: true, tituloDialogo, mensajeDialogo });
        }
      } else {
        tituloDialogo = 'pagos:tituloerror';
        mensajeDialogo.push('pagos:errorgeneral');
        mensajeDialogo.push(resws.data.messageError);
        if (!resws.data.showMessage) {
          mensajeDialogo = [];
          mensajeDialogo.push('pagos:subtituerror');
        }
        this.setState({ muestraAlerta: true, tituloDialogo, mensajeDialogo, completa: true });
      }
    }
  }

  reset = () => {
    /* Reinicio de las transacciones */
    this.setState(initialState);
  }

  errorAuthorize = mensajeDialogo => {
    const tituloDialogo = "Pago rechazado";
    this.setState({ muestraAlerta: true, tituloDialogo, mensajeDialogo });
  };

  consultarCuentas = async () => {
    const { valorBusqueda } = this.state;
    let url = process.env.REACT_APP_URL_CUENTAS_DEV;
    if (process.env.NODE_ENV === 'production') {
      url = process.env.REACT_APP_URL_CUENTAS_PROD;
    }
    // console.log('=============')
    // console.log(' URL : [' + url + ']')
    // console.log('=============')
    let parametros = { userId: '764580121' };
    if (this.state.tipoBusqueda === 'teléfono') {
      parametros.telefono_origen = valorBusqueda;
      parametros.numero_cuenta = null;
    } else {
      parametros.telefono_origen = null;
      parametros.numero_cuenta = valorBusqueda;
    }
    let resws;
    let credenciales = process.env.REACT_APP_CLIENT_CREDENTIALS_DEV;
    if (process.env.NODE_ENV === 'production') {
      credenciales = process.env.REACT_APP_CLIENT_CREDENTIALS_PROD;
    }

    const headers = {
      'Authorization': 'Basic ' + credenciales
    }
    // console.log('CREDENCIALES', headers)
    try {
      resws = await axios
        .post(url, parametros, {
          headers: headers
        });
    } catch (err) {
      // console.log('err', err);
      this.setState({ muestraAlerta: true, mensajeDialogo: ["pagos:errorgeneral"], completa: true });
      return;
    }
    // console.log("[respuesta] accounts", resws.data.accounts);
    if (typeof resws.data.accounts === 'undefined') {
      if (resws.data.error) {
        if (resws.data.error === 'invalid_token') {
          this.setState({ muestraAlerta: true, mensajeDialogo: ["notoken"] });
          this.setState({ valorBusqueda: '', codigoPostal: '' });
          return;
        } else {
          this.setState({ muestraAlerta: true, mensajeDialogo: ["errordesco"] });
          return;
        }
      }
      if (resws.data.responseStatus && resws.data.responseStatus.responseMessage) {
        if (resws.data.responseStatus.responseCode === 37) {
          this.setState({ muestraAlerta: true, mensajeDialogo: ["cuentanoexiste"] });
        } else {
          this.setState({ muestraAlerta: true, mensajeDialogo: [resws.data.responseStatus.responseMessage] });
        }
      } else {
        this.setState({ muestraAlerta: true, mensajeDialogo: ["errordesco"] });
      }
      this.setState({ valorBusqueda: '', codigoPostal: '' });
      return;
    } else {
      // console.log("[respuesta] accounts", resws.data.accounts.length);
      // console.log("[respuesta] Cuentas", resws.data);
      this.setState({ respCuentasMovil: resws.data });
      this.obtieneCuentas(resws.data);
    }
  };

  consultaParametrosAuthorize = async ()  => {
    //valida si ya se tienen los datos antes de volver a solicitar nuevamente las credenciales
    if(this.state.parametrosEmbebido.valor1 != null && this.state.parametrosEmbebido.valor2 != null && this.state.parametrosEmbebido.valor3 != null){
      return;
    }
    let url = process.env.REACT_APP_URL_PARAMETROS_EMBEBIDO_DEV;
    if (process.env.NODE_ENV === 'production') {
      url = process.env.REACT_APP_URL_PARAMETROS_EMBEBIDO_PROD;
    }
    console.log(url);
    let resws;
    let parametros = { userId: '764580121' };
    let credenciales = process.env.REACT_APP_CLIENT_CREDENTIALS_DEV;
    if (process.env.NODE_ENV === 'production') {
      credenciales = process.env.REACT_APP_CLIENT_CREDENTIALS_PROD;
    }
  
    const headers = {
      'Authorization': 'Basic ' + credenciales
    }
    try {
      resws = await axios
        .post(url, parametros, {
          headers: headers
        });
    } catch (err) {
      this.state.parametrosEmbebido = {valor1: null, valor2: null, valor3: null}
      this.setState({ muestraAlerta: true, mensajeDialogo: ["pagos:errorgeneral"], completa: true });
      return;
    }

    this.state.parametrosEmbebido= resws.data;
    console.log("parametros obtenidos");
  }

  obtieneCuentas = respCuentasMovil => {
    this.setState({
      respCuentasMovil,
      cuentasMovil: {}
    });
    // console.log("obtieneCuentas", this.state.respCuentasMovil.accounts.length);

    if (this.state.respCuentasMovil.accounts.length > 0) {
      this.setState({ cuentasMovil: this.state.respCuentasMovil.accounts });
      // console.log("cuentasServicio", this.state.cuentasMovil);
    }
  };

  establecerTipoBusqueda = (tipoBusqueda) => {
    this.setState({ tipoBusqueda });
  };

  establecerCaptcha = (valorCaptcha) => {
    this.setState({ captchaValido: !(valorCaptcha === null) });
  }

  reiniciarCaptcha = (valor) => {
    this.setState({ captchaExpiro: valor });
  }

  establecerValoresBusqueda = (nombre, valor) => {
    if (nombre === 'telefono_origen' || nombre === 'numero_cuenta') {
      this.setState({ valorBusqueda: valor });
    } else {
      this.setState({ codigoPostal: valor });
    }

  };

  limpiarCuentas = limpia => {
    const cuentasMovil = {};
    if (limpia) {
      this.setState({ cuentasMovil });
    }
  };

  handleSelectAllAccounts = (event, nuevasSeleccionadas, estatus) => {
    if (event.target.checked) {
      const cuentasSelectas = nuevasSeleccionadas.filter(n =>
        this.state.cuentasSeleccionadas.findIndex(c =>
          c.accountNumber === n.accountNumber) === -1);
      this.setState({
        cuentasSeleccionadas:
          this.state.cuentasSeleccionadas.concat(cuentasSelectas)
      });
      return;
    }
    const cuentasDescartadas = this.state.cuentasSeleccionadas.filter(c => c.accountStatus !== estatus);
    this.setState({ cuentasSeleccionadas: cuentasDescartadas });
  }

  handleSelectOneAccount = (event, cuenta) => {
    const nuevaCuentaSeleccionada = this.state.respCuentasMovil.accounts.filter(c => c.accountNumber === cuenta);
    this.setState({ cuentasSeleccionadas: nuevaCuentaSeleccionada });
  }

  handleSelectAccount = (event, cuenta) => {
    const indiceSeleccionado = this.state.cuentasSeleccionadas.findIndex(c => c.accountNumber === cuenta);
    let nuevaSeleccionada = [];

    if (indiceSeleccionado === -1) {
      nuevaSeleccionada = nuevaSeleccionada.concat(this.state.cuentasSeleccionadas,
        this.state.respCuentasMovil.accounts.filter(c => c.accountNumber === cuenta));
    } else if (indiceSeleccionado === 0) {
      nuevaSeleccionada = nuevaSeleccionada.concat(this.state.cuentasSeleccionadas.slice(1));
    } else if (indiceSeleccionado === this.state.cuentasSeleccionadas.length - 1) {
      nuevaSeleccionada = nuevaSeleccionada.concat(this.state.cuentasSeleccionadas.slice(0, -1));
    } else if (indiceSeleccionado > 0) {
      nuevaSeleccionada = nuevaSeleccionada.concat(
        this.state.cuentasSeleccionadas.slice(0, indiceSeleccionado),
        this.state.cuentasSeleccionadas.slice(indiceSeleccionado + 1),
      );
    }

    this.setState({ cuentasSeleccionadas: nuevaSeleccionada });
  };

  handleDialog = () => {
    const prevPasoActivo = this.state.pasoActivo;
    let unidad = 1;
    // console.log('muestraInactividad', this.state.muestraInactividad);
    // console.log('estaInactivo', this.state.estaInactivo);
    if (this.state.muestraInactividad) {
      // console.log('----- IS ALIVE -----');
      this.setState({ muestraInactividad: false });
      return;
    }
    if (prevPasoActivo === pasos.length - 1) {
      unidad = 0;
    }
    this.setState({ muestraAlerta: false, pasoActivo: prevPasoActivo - unidad });
    if (this.state.completa) {
      this.reset();
    }
  }

  esPasoOpcional = paso => {
    return paso === 4;
  };

  esPasoOmitido = paso => {
    return this.state.omitidos.has(paso);
  };

  obtenerContenidoPaso = paso => {
    switch (paso) {
      case 0:
        return 'pagos:instrucciones.pasouno';
      case 1:
        return 'pagos:instrucciones.pasodos-' + this.state.tipoBusqueda;
      case 2:
        return 'pagos:instrucciones.pasotres';
      case 3:
        return 'pagos:instrucciones.pasocuatro';
      // case 4:
      //   return 'Este paso se puede omitir';
      // case 5:
      //   return 'Presione \'Pagar\' he ingrese los datos';
      default:
        return 'pagos:intrucciones.pasodesconocido';
    }
  };

  handleReset = () => {
    this.setState({ pasoActivo: 0 });
  };

  handleBack = () => {
    const prevPasoActivo = this.state.pasoActivo;
    let { tipoBusqueda, cuentasMovil, valorBusqueda, codigoPostal, cuentasSeleccionadas } = this.state;
    if (prevPasoActivo - 1 === 0) {
      tipoBusqueda = '';
    } else if (prevPasoActivo - 1 === 1) {
      cuentasMovil = {};
      valorBusqueda = '';
      codigoPostal = '';
    } else if (prevPasoActivo - 1 === 2) {
      cuentasSeleccionadas = [];
    }

    this.setState({ pasoActivo: prevPasoActivo - 1, tipoBusqueda, cuentasMovil, valorBusqueda, codigoPostal, cuentasSeleccionadas });
  };

  handleSkip = () => {
    if (!this.esPasoOpcional(this.state.pasoActivo)) {
      throw new Error("No puedes omitir este paso.")
    }
    //console.log('nuevas cuentas', this.state.cuentasSeleccionadas);
    const prevPasoActivo = this.state.pasoActivo;
    const prevOmitidos = this.state.omitidos;
    const nuevosOmitidos = new Set(prevOmitidos.values());
    nuevosOmitidos.add(this.state.pasoActivo);

    this.setState({ pasoActivo: prevPasoActivo + 1, omitidos: nuevosOmitidos, errorDestinoNotifica: '' });

  };

  handleNext = () => {
    let nuevosOmitidos = this.state.omitidos;
    let pagosSugeridos = new Map();
    let pagosIngresados = new Map();
    let erroresPagos = new Map();
    let cuentasSeleccionadas = this.state.cuentasSeleccionadas;
    let errorDestinoNotifica = "";
    let cuenta = "";
    this.consultaParametrosAuthorize();

    if (this.esPasoOmitido(this.state.pasoActivo)) {
      nuevosOmitidos = new Set(nuevosOmitidos.values());
      nuevosOmitidos.delete(this.state.pasoActivo);
    }
    const prevPasoActivo = this.state.pasoActivo;
    /* Consulta cuentas */
    if (prevPasoActivo === 1) {
      this.consultarCuentas();
      window.grecaptcha.reset();
      this.setState({ captchaValido: false })
    }
    
    if (prevPasoActivo === 2) {
      this.consultarCuentas();
      this.state.cuentasSeleccionadas.forEach(c => {
        cuenta = this.state.respCuentasMovil.accounts.find(o => o.accountNumber === c.accountNumber);
        // console.error('respCuentas', this.state.respCuentasMovil.accounts);
        pagosIngresados.set(c.accountNumber, parseFloat(cuenta.suggestedPayment).toFixed(2));
      });
      this.state.cuentasSeleccionadas.forEach(c => {
        pagosSugeridos.set(c.accountNumber, "");
        erroresPagos.set(c.accountNumber, "");
      });
    }
    if (prevPasoActivo === 3) {
      /* Modificar cuentasSeleccionadas en función de los nuevosPagosSugeridos */
      pagosSugeridos = this.state.pagosSugeridos;
      erroresPagos = this.state.erroresPagos;
      pagosSugeridos.forEach((v, k) => {
        // console.warn(k,v);
        let index = cuentasSeleccionadas.findIndex(c => c.accountNumber === k);
        // console.error('antes', cuentasSelectas[index].suggestedPayment);
        cuentasSeleccionadas[index].suggestedPayment = v;
      });
    }

    if (prevPasoActivo === 4) {
      /* Validar destino de notificación */
      const { destinoNotificacion } = this.state;
      if (destinoNotificacion !== '') {
        // const emailRegex = /^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+.)+([a-zA-Z0-9]{2,4})+$/;
        const emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/; //eslint-disable-line
        if (!emailRegex.test(destinoNotificacion)) {
          errorDestinoNotifica = "pagos:correofmterr";
          const numbersRegex = /^[0-9]*$/;
          if (numbersRegex.test(destinoNotificacion)) {
            const phoneRegex = /^[0-9]{10}$/;
            if (!phoneRegex.test(destinoNotificacion)) {
              errorDestinoNotifica = "pagos:movilfmterr";
              this.setState({ errorDestinoNotifica });
              return;
            } else {
              errorDestinoNotifica = "";
              this.setState({ tipoNotificacion: 'sms', errorDestinoNotifica });
            }
          } else {
            this.setState({ errorDestinoNotifica });
            return;
          }
        } else {
          errorDestinoNotifica = "";
          this.setState({ tipoNotificacion: 'e-mail', errorDestinoNotifica });
        }
      }
    }

    this.setState({ omitidos: nuevosOmitidos, pagosSugeridos, pagosIngresados, erroresPagos, cuentasSeleccionadas, pasoActivo: prevPasoActivo + 1 });
  };

  habilitarSiguiente = () => {
    const { pasoActivo, tipoBusqueda, valorBusqueda, cuentasSeleccionadas, captchaValido } = this.state;
    //console.error('captchaValido', captchaValido);
    if (pasoActivo === 0 && tipoBusqueda === '') {
      return true;
    } else if (pasoActivo === 1 && (valorBusqueda === '' || !captchaValido)) {
      return true;
    } else if (pasoActivo === 2 && cuentasSeleccionadas.length === 0) {
      return true;
    } else if (pasoActivo === 3) {
      let tieneVacio = true;
      let valoresPagos = this.state.pagosSugeridos.values();
      /* Valida nulos */
      for (let valor of valoresPagos) {
        tieneVacio = false;
        if (valor === "") {
          tieneVacio = true;
          break;
        }
      }
      /* Valida máximos y mínimos */
      let errorMaxMin = true;
      let valoresErrores = this.state.erroresPagos.values();
      for (let error of valoresErrores) {
        errorMaxMin = false;
        if (error !== "") {
          errorMaxMin = true;
          break;
        }
      }
      return tieneVacio || errorMaxMin;
    }
    return false;
  };

  actualizarPago = (nuevosPagos, erroresPagos) => {
    // console.info('nuevosPagos', nuevosPagos);
    // console.info('erroresPagos', erroresPagos);
    let cuentasSeleccionadas = this.state.cuentasSeleccionadas;

    /* Modificar cuentasSeleccionadas en función de los nuevosPagosSugeridos */
    nuevosPagos.forEach((v, k) => {
      // console.warn(k,v);
      let index = cuentasSeleccionadas.findIndex(c => c.accountNumber === k);
      // console.error('antes', cuentasSelectas[index].suggestedPayment);
      cuentasSeleccionadas[index].suggestedPayment = v;
    });
    this.setState({ pagosSugeridos: nuevosPagos, erroresPagos, cuentasSeleccionadas });
  };

  establecerNotificar = (destinoNotificacion) => {
    let errorDestinoNotifica;
    if (destinoNotificacion === '') {
      errorDestinoNotifica = '';
      this.setState({ destinoNotificacion, errorDestinoNotifica });
    } else {
      if (destinoNotificacion !== '') {
        // const emailRegex = /^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+.)+([a-zA-Z0-9]{2,4})+$/;
        const emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/; //eslint-disable-line
        if (!emailRegex.test(destinoNotificacion)) {
          errorDestinoNotifica = "pagos:correofmterr";
          const numbersRegex = /^[0-9]*$/;
          if (numbersRegex.test(destinoNotificacion)) {
            const phoneRegex = /^[0-9]{10}$/;
            if (!phoneRegex.test(destinoNotificacion)) {
              errorDestinoNotifica = "pagos:movilfmterr";
              this.setState({ errorDestinoNotifica });
              return;
            } else {
              errorDestinoNotifica = "";
              this.setState({ tipoNotificacion: 'sms', errorDestinoNotifica, destinoNotificacion });
            }
          } else {
            this.setState({ errorDestinoNotifica });
            return;
          }
        } else {
          errorDestinoNotifica = "";
          this.setState({ tipoNotificacion: 'e-mail', errorDestinoNotifica, destinoNotificacion });
        }
      }
    }
  }

  render() {
    const { classes } = this.props;
    const { t } = this.props;

    const encabezadoTabla = [
      { id: "accountNumber", label: t('numerocuenta') },
      { id: "productName", label: t('servicio') },
      { id: "accountStatus", label: t('estado') },
      { id: "customerName", label: t('cliente') },
      { id: "lastPayment", label: t('fechaultpago') }
    ];

    const encabezadoTablaConfirma = [
      { id: "accountNumber", label: t('numerocuenta') },
      { id: "productName", label: t('servicio') },
      { id: "customerName", label: t('cliente') },
      { id: "suggestedPay", label: t('pagosugerido') },
      { id: "enterPay", label: t('ingresarpago') },
    ];
    // console.error("=============")
    // console.error("this.state.cuentasSeleccionadas", this.state.cuentasSeleccionadas)
    // console.error("=============")

    const onChangeCaptcha = value => {

      if (value === null) {
        // console.info("Reinicio de captcha", this.state.pasoActivo);
        if (this.state.pasoActivo === 1) {
          this.setState(initialState);
        }
        this.setState({ captchaExpiro: true });
        return;
      }
      // console.info("Validacion de captcha");
      this.setState({ captchaValido: !(value === null) });
    };

    return (
      <div style={{ backgroundColor: "#fff" }}>
        <MuiThemeProvider theme={theme}>
          <IdleTimer
            ref={ref => { this.idleTimer = ref }}
            element={document}
            onActive={this.onActive}
            onIdle={this.onIdle}
            onAction={this.onAction}
            debounce={250}
            timeout={this.state.timeout} />

          <CssBaseline />
          <Encabezado />
          <div className={classes.root}>
            {this.state.muestraProgreso &&
              <LinearProgress variant="query" color="secondary" />
            }
            <Grid container>
              <Grid item xs={12}>
                <Grid container justify="center" spacing={0} className={classes.stepper}>
                  <Stepper activeStep={this.state.pasoActivo} alternativeLabel>
                    {pasos.map((etiqueta, indice) => {
                      const stepProps = {};
                      const labelProps = {};
                      if (this.esPasoOpcional(indice)) {
                        labelProps.optional = <Typography variant="caption">(Opcional)</Typography>;
                      }
                      if (this.esPasoOmitido(indice)) {
                        stepProps.completed = false;
                      }
                      return (
                        <Step key={etiqueta} {...stepProps}>
                          <StepLabel {...labelProps}>{t(etiqueta)}</StepLabel>
                        </Step>
                      );
                    })}
                  </Stepper>
                </Grid>
              </Grid>
            </Grid>

            <Grid container>
              <Grid item xs={12}>
                <Grid container justify="center" spacing={0}>
                  <MuestraAlerta
                    handleDialog={this.handleDialog}
                    mostrarDialogo={this.state.muestraAlerta}
                    tituloDialogo={this.state.tituloDialogo}
                    mensajeDialogo={this.state.mensajeDialogo}
                    valoresDialogo={this.state.valoresDialogo}
                    detalleDialogo={this.state.detalleDialogo}
                    valoresDetalleDialogo={this.state.valoresDetalleDialogo}
                    botonContinuar={'pagos:botondialogo'}
                    botonTerminar={''}
                    handleReset={this.reset}
                  />
                  {this.state.pasoActivo === 0 ? (
                    <EscogerBusqueda
                      onSelectTipo={tipo => this.establecerTipoBusqueda(tipo)}
                      onResetCaptcha={val => this.reiniciarCaptcha(val)}
                      captchaExpiro={this.state.captchaExpiro}
                    />
                  ) : null}
                  {this.state.pasoActivo === 1 ? (
                    <AccountForm
                      tipoBusqueda={this.state.tipoBusqueda}
                      onChangeInput={(nombre, valor) => this.establecerValoresBusqueda(nombre, valor)}
                      obtieneCuentas={respCuentasMovil =>
                        this.obtieneCuentas(respCuentasMovil)
                      }
                    />
                  ) : null}
                  {this.state.pasoActivo >= 3 ? (
                    <AcuseRecibo
                      errorDestinoNotifica={this.state.errorDestinoNotifica}
                      onChangeNotificar={this.establecerNotificar}
                    />
                  ) : null}
                </Grid>
              </Grid>
            </Grid>

            <Grid container>
              <Grid item xs={12}>
                <Grid container justify="center" spacing={0}>
                  {this.state.pasoActivo === 1 ? (
                    <ReCAPTCHA
                      sitekey="6LcJStgZAAAAAGThDJHA-NahZC2Ja0hkqGjQoQig"
                      onChange={onChangeCaptcha}
                    />
                  ) : null}
                </Grid>
              </Grid>
            </Grid>

            {this.state.pasoActivo > 1 && this.state.pasoActivo <= 2 ? (
              <div ref={el => { this.el = el; }}>
                <CuentasServicio
                  tituloTabla={t('cuentasactivas')}
                  titulosColumnas={encabezadoTabla}
                  cuentasServicio={this.state.cuentasMovil}
                  estatusCuentas={'ACTIVE'}
                  onSelectAllAccounts={this.handleSelectAllAccounts}
                  onSelectedAccount={this.handleSelectOneAccount}
                  captchaValido={true}
                  cuentaParaPago={this.state.cuentasSeleccionadas}
                />
                <CuentasServicio
                  tituloTabla={t('cuentascancel')}
                  titulosColumnas={encabezadoTabla}
                  cuentasServicio={this.state.cuentasMovil}
                  estatusCuentas={'CANCELLED'}
                  onSelectAllAccounts={this.handleSelectAllAccounts}
                  onSelectedAccount={this.handleSelectOneAccount}
                  captchaValido={true}
                  cuentaParaPago={this.state.cuentasSeleccionadas}
                />
              </div>
            ) : null}
            {this.state.pasoActivo === 3 ? (
              <CuentasConfirma
                pagosIngresados={this.state.pagosIngresados}
                pagosSugeridos={this.state.pagosSugeridos}
                erroresPagos={this.state.erroresPagos}
                titulosColumnas={encabezadoTablaConfirma}
                cuentasParaPago={this.state.cuentasSeleccionadas}
                onEditPayment={(nuevosPagos, erroresPagos) => {
                  this.actualizarPago(nuevosPagos, erroresPagos)
                }}
              />
            ) : null}
            <Grid container>
              <Grid item xs={12}>
                <Grid container justify="center" spacing={0}>
                  <div>
                    {/* {this.state.pasoActivo === pasos.length ? (
                      <div>

                        <Typography className={classes.instructions}>
                          Todos los pasos han sido completados
                        </Typography>
                        <Button onClick={this.handleReset} className={classes.button}>
                          Reinicio
                        </Button>
                      </div>
                    ) : ( */}
                    <div >
                      <Typography color="secondary" variant="h6" className={classes.instructions}>{t(this.obtenerContenidoPaso(this.state.pasoActivo))}</Typography>
                      {/* {this.state.pasoActivo === 1 && (
                          <Typography color="primary" variant="h6" className={classes.instructions}>Recuerde ingresar el mismo zip code en la forma de pago
                          </Typography>
                        )} */}
                      <div style={{ textAlign: "center" }} >
                        <Button
                          disabled={this.state.pasoActivo === 0}
                          onClick={this.handleBack}
                          className={classes.button}
                          variant="outlined"
                          color="secondary"
                          startIcon={<NavigateBeforeIcon />}
                        >
                          {t('anterior')}
                        </Button>
                        {this.esPasoOpcional(this.state.pasoActivo) && (
                          <Button
                            variant="contained"
                            color="secondary"
                            onClick={this.handleSkip}
                            className={classes.button}
                          >
                            Omitir
                          </Button>
                        )}
                        <BotonAuthorize
                          muestra={this.state.pasoActivo === pasos.length - 1 ? 'inline-flex' : 'none'}
                          deshabilita={this.habilitarSiguiente()}
                          errorDestinoNotifica={this.state.errorDestinoNotifica}
                          pagoEnProgreso={this.state.muestraProgreso}
                          identificador={this.state.parametrosEmbebido.valor1}
                          llave={this.state.parametrosEmbebido.valor2}
                          urlEmbebido={this.state.parametrosEmbebido.valor3}
                        />
                        {this.state.pasoActivo < pasos.length - 1 ? (
                          <Button
                            disabled={this.habilitarSiguiente()}
                            variant="contained"
                            color="secondary"
                            onClick={this.handleNext}
                            className={classes.button}
                            endIcon={<NavigateNextIcon />}
                          >
                            {t('siguiente')}
                          </Button>
                        ) : null}
                      </div>
                    </div>
                    {/*)}*/}
                  </div>
                </Grid>
              </Grid>
            </Grid>

          </div>
          {/* {this.state.pasoActivo > 1 && this.state.pasoActivo <= 2 ? (
            <div>
              <CuentasServicio
                tituloTabla={t('cuentasactivas')}
                titulosColumnas={encabezadoTabla}
                cuentasServicio={this.state.cuentasMovil}
                estatusCuentas={'ACTIVE'}
                onSelectAllAccounts={this.handleSelectAllAccounts}
                onSelectedAccount={this.handleSelectAccount}
                captchaValido={true}
              />
              <CuentasServicio
                tituloTabla={t('cuentascancel')}
                titulosColumnas={encabezadoTabla}
                cuentasServicio={this.state.cuentasMovil}
                estatusCuentas={'CANCELLED'}
                onSelectAllAccounts={this.handleSelectAllAccounts}
                onSelectedAccount={this.handleSelectAccount}
                captchaValido={true}
              />
            </div>
            ) : null}
            {this.state.pasoActivo === 3 ? (
              <CuentasConfirma 
                pagosSugeridos={this.state.pagosSugeridos}
                erroresPagos={this.state.erroresPagos}
                titulosColumnas={encabezadoTablaConfirma}
                cuentasParaPago={this.state.cuentasSeleccionadas}
                onEditPayment={(nuevosPagos, erroresPagos) => { 
                  this.actualizarPago(nuevosPagos, erroresPagos)}}
              />
            ) : null} */}
          <div style={{ padding: "60px" }} />
          <PiePagina />
          <MuestraAlerta
            handleDialog={this.handleDialog}
            mostrarDialogo={this.state.muestraInactividad}
            tituloDialogo={'pagos:tituloinactivo'}
            mensajeDialogo={['pagos:mensajeinactivo']}
            valoresDialogo={[]}
            detalleDialogo={[]}
            valoresDetalleDialogo={[]}
            botonContinuar={'pagos:botonsesion'}
            botonTerminar={'pagos:botonterminar'}
            handleReset={this.reset}
          />
        </MuiThemeProvider>
      </div>
    );
  }
}

export default withTranslation('pagos')(withStyles(styles)(App));
